<template>
  <div class="wrapper" id="wrapper" :class="{ disabled: isLocked }" @click="$emit('click', true)">
    <div class="wrapper-content" :class="{ disabled: isLocked }">
      <slot></slot>
    </div>
    <v-premium-plan-popup
      v-if="isLocked"
      :text="text"
      ref="wrapperPremiumLock"
      style="border-radius: 5px;"
    ></v-premium-plan-popup>
  </div>
</template>

<script>
export default {
  props: {
    isLocked: {
      type: Boolean,
      default: () => false
    },
    text: {
      type: String,
      default: () => ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isLocked) {
        this.calWrapperHeight()
      }
    })
  },
  methods: {
    async calWrapperHeight() {
      await new Promise(resolve => setTimeout(resolve, 1000))
      var parent = document.getElementById('wrapper')
      const child = this.$refs.wrapperPremiumLock.$refs.premiumLock
      if (parent && child) {
        parent.style.height = child.offsetHeight + 'px'
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  position: relative;
}
.wrapper.disabled {
  cursor: auto !important;
}

.wrapper-content.disabled {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/PremiumPlanLayout.vue